import React from "react";
import "./Techstacks.css";
import { FaReact, FaSass, FaJira, FaBitbucket } from "react-icons/fa";

import {
  SiHtml5,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { SiJavascript, SiStrapi, SiNextdotjs, SiStorybook } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { BsBootstrap } from "react-icons/bs";


export const Techstacks = () => {
  return (
    <>
      <div className="section main" data-aos="fade-right">
        <h2 className="section__title different">Skills</h2>
        <div className="techsection">
          <div>
            <SiJavascript />
            <h5>Javascript</h5>
          </div>
          <div>
            <SiHtml5 />
            <h5>HTML</h5>
          </div>
          <div>
            <DiCss3 />
            <h5>CSS</h5>
          </div>
          <div>
            <FaReact />
            <h5>React js</h5>
          </div>
          <div>
            <SiNextdotjs />
            <h5>Next js</h5>
          </div>
          <div>
            <SiStorybook />
            <h5>Storybook</h5>
          </div>
          <div>
            <BsBootstrap />
            <h5>Bootstrap</h5>
          </div>
          <div>
            <FaSass />
            <h5>SASS</h5>
          </div>
          <div>
            <SiStrapi />
            <h5>Strapi</h5>
          </div>
          <div>
            <VscGithub />
            <h5>Github</h5>
          </div>
          <div>
            <FaJira />
            <h5>Jira</h5>
          </div>
          <div>
            <FaBitbucket />
            <h5>Bitbucket</h5>
          </div>
        </div>
      </div>
    </>
  );
};
